var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgSaveCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45935 7.42647C6.45935 6.50058 7.20993 5.75 8.13582 5.75H15.1344C15.6133 5.75 16.0693 5.95478 16.3874 6.31268L18.2859 8.44846C18.5587 8.75534 18.7094 9.15166 18.7094 9.56225V16.3235C18.7094 17.2494 17.9588 18 17.0329 18H8.13582C7.20993 18 6.45935 17.2494 6.45935 16.3235V7.42647Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6344 2.5H5.63582C4.29572 2.5 3.20935 3.58637 3.20935 4.92647V13.8235",
    stroke: "#1F1F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4594 8.75H9.45935",
    stroke: "#1F1F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70935 18V16C9.70935 15.4477 10.1571 15 10.7094 15H14.4943C15.0466 15 15.4943 15.4477 15.4943 16V18",
    stroke: "#1F1F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSaveCopy);
export default __webpack_public_path__ + "static/media/img_save _copy.7df298e56d0adaf49f227ac19dbd93ef.svg";
export { ForwardRef as ReactComponent };